<template>
  <!-- 报名确认弹窗 -->
  <van-popup v-model="showPopup" class="transparent-popup" position="bottom">
    <div class="v-pop-reg">
      <div class="btn-close" @click="close"></div>
      <div class="content">
        <div class="title">报名信息</div>
        <!-- 表单 -->
        <div class="v-form-prize">
          <van-form @submit="onSubmit" :show-error-message="false">
            <div class="form-item">
              <div class="act-box">
                <div class="act-label">活动名称</div>
                <div class="act-name">{{ info.activityName }}</div>
              </div>
            </div>

            <div v-if="!info.userInfo.idcard" class="form-item form-item-aleft">
              <van-field
                label="参与用户"
                class="c-int"
                value="请先完成实名认证"
                readonly
              />
              <div class="cert" @click="handleCert">去认证</div>
            </div>

            <div v-if="info.userInfo.idcard" class="form-item">
              <van-field
                label="姓名"
                class="c-int"
                :value="info.userInfo.name"
                readonly
              />
            </div>

            <div v-if="info.userInfo.idcard" class="form-item">
              <van-field
                label="证件号码"
                class="c-int"
                :value="info.userInfo.idcard"
                readonly
              />
            </div>

            <div
              v-if="superInfo.activityCategory != 2"
              class="form-item form-item-long"
            >
              <van-field
                label="开奖及候补时间"
                class="c-int"
                :value="drawStartTime + '-' + drawEndTime"
                readonly
              />
            </div>

            <div
              v-if="superInfo.activityCategory == 2"
              class="form-item form-item-long"
            >
              <van-field
                label="榜单公示时间"
                class="c-int"
                :value="drawStartTime"
                readonly
              />
            </div>

            <div
              v-if="superInfo.activityCategory != 2"
              class="form-item form-item-long"
            >
              <!-- <van-field label="设置开奖提醒" class="c-int" readonly />
              <div class="reminder">
                设置提醒<van-switch v-model="checked" size="18px" />
              </div> -->

              <div class="act-box act-box-rem">
                <div class="act-label">
                  <div class="alabel">设置开奖提醒</div>
                  <div class="tips">开奖10分钟内未确认则中奖作废</div>
                </div>
                <div class="act-name">
                  <div class="reminder">
                    {{ checked ? "已设置" : "未设置"
                    }}<van-switch
                      v-model="checked"
                      size="18px"
                      active-color="#8AC4F6"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- 用户协议 -->
            <div class="agree">
              <van-checkbox
                v-model="checkedMg"
                @change="handleMg"
                checked-color="#8AC4F6"
              />
              <span class="t1"
                >我已阅读并同意<span class="t-xy" @click="handleAgree"
                  >《用户规则》</span
                >，且知悉风险</span
              >
            </div>

            <div class="ft-btn">
              <van-button class="c-btn" block type="info" native-type="submit">
                确认报名
              </van-button>
            </div>
          </van-form>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { mapState } from "vuex";
import service from "@utils/service.js";
import {
  Popup as VanPopup,
  Field as vanField,
  Form as vanForm,
  button as vanButton,
  Switch as vanSwitch,
  checkbox as vanCheckbox,
  Toast,
} from "vant";

import { setStorage, getStorage } from "@utils/storage";
import { jumpPage, getQuery } from "@utils/url";
import { formatDate } from "@utils/utils";
import { statClick } from "@utils/h5-report";

export default {
  name: "VPopImg",

  components: {
    VanPopup,
    vanField,
    vanForm,
    vanButton,
    vanSwitch,
    vanCheckbox,
  },

  props: {
    superInfo: {
      type: Object,
      default: () => {},
    },
  },

  watch: {
    superInfo: {
      immediate: true,
      handler(newVal) {
        this.info = newVal;
      },
    },
  },

  data() {
    let superId = getQuery("superId") || "";
    return {
      superId,
      // 报名信息
      info: this.superInfo,
      // 展示弹窗
      showPopup: false,
      // 表单
      // 输入框只读
      readonly: false,
      // switch 是否选中
      checked: true,

      // 同意协议
      agreementMg: false,
      checkedMg: false,
      checkeAgree: require("../assets/image/agree.png"),
      checkeAgreeYes: require("../assets/image/agree-yes.png"),
      // 开奖登记时间

      drawStartTime: formatDate(this.superInfo.drawStartTime, "point"),
      drawEndTime: formatDate(this.superInfo.drawEndTime, "hhmm"),
    };
  },
  computed: {
    ...mapState(["userInfo", "identity"]),
  },
  mounted() {
    const agreeMg = getStorage("agreeMg");
    if (agreeMg == 1) {
      this.checkedMg = true;
    }
  },

  methods: {
    // 显示弹窗
    open() {
      this.showPopup = true;
    },
    // 关闭弹窗
    close() {
      this.showPopup = false;
    },

    // 表单提交
    async onSubmit() {
      console.log("表单提交");
      // 数据上报
      statClick(
        {
          actid: this.superId,
          identity: this.identity,
        },
        {
          cont: "点击确认",
          mod: "confirm",
        },
      );
      if (!this.info.userInfo.idcard) {
        Toast("请先完成实名认证");
        return;
      }
      if (!this.checkedMg) {
        Toast("请先同意用户规则");
        return;
      }

      let params = {
        ticket: this.userInfo.ticket,
        activityId: this.superId,
        isRemind: this.checked ? 1 : 0,
      };
      const res = await service.setSignup(params);
      if (res.errno === "0") {
        this.showPopup = false;
        this.$emit("success");
        // Toast("报名成功");
      } else {
        Toast(res.msg || "报名失败");
      }
    },
    // 同意芒果协议
    handleMg(e) {
      this.checkedMg = e;
      if (e) {
        setStorage("agreeMg", 1);
      } else {
        setStorage("agreeMg", 0);
      }
    },

    // 点击协议
    handleAgree() {
      jumpPage("https://d.mgtv.com/zb-nPe");
    },

    // 去认证
    handleCert() {
      console.log("🚀 ~ 去认证:");
      this.$emit("goCert");
    },
  },
};
</script>

<style lang="less">
// 弹窗背景透明
.transparent-popup {
  background-color: transparent !important;
}
//  图片弹窗
.v-pop-reg {
  position: relative;
  width: 100%;
  .btn-close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 22px;
    height: 22px;
    background-image: url("../assets/image/icon-pop-close.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center top;
  }
  .content {
    padding: 25px 0;
    border-radius: 35px 35px 0 0;
    font-size: 14px;
    font-weight: 400;
    background: #fff;
    text-align: center;
    .title {
      margin-bottom: 20px;
      color: #000;
      font-size: 17px;
      font-weight: 600;
    }

    .v-form-prize {
      .form-item {
        position: relative;
        margin-bottom: 10px;
        .cert {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          right: 38px;
          top: 12px;
          z-index: 20;
          width: 63px;
          height: 27px;
          font-weight: 400;
          font-size: 12px;
          color: #001a33;
          background-image: url("../assets/image/icon-cert.png");
          background-repeat: no-repeat;
          background-size: 100% auto;
          background-position: center top;
        }

        .van-field__label {
          width: 60px;
          font-weight: 500;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.9);
        }
        .van-field__control {
          text-align: right;
          font-weight: 400;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.6);
        }

        .act-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 335px;
          min-height: 50px;
          padding: 17px 20px;
          margin: 0 auto;
          background: rgba(0, 0, 0, 0.03);
          border: 0 none;
          border-radius: 15px;
          font-size: 14px;
          box-sizing: border-box;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.8);
          .act-label {
            width: 72px;
            text-align: left;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.9);
          }
          .act-name {
            width: 231px;
            text-align: right;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.8);
          }
        }

        .act-box-rem {
          padding: 20px;
          .act-label {
            width: 190px;
            .tips {
              margin-top: 6px;
              font-weight: 400;
              font-size: 11px;
              color: rgba(0, 0, 0, 0.5);
            }
          }
          .act-name {
            width: 115px;
            .reminder {
              display: flex;
              align-items: center;
              justify-content: right;
              font-weight: 400;
              font-size: 12px;
              color: rgba(0, 0, 0, 0.6);
              .van-switch {
                margin-left: 10px;
              }
            }
          }
        }
      }
      .form-item-aleft {
        .van-field__control {
          text-align: left;
          font-weight: 400;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.6);
        }
      }
      .form-item-long {
        .van-field__label {
          width: 110px;
        }
      }
      .van-cell {
        position: relative;
        z-index: 10;
        padding: 17px 20px;
      }
      .van-cell::after {
        display: none;
      }

      .c-int,
      .c-area {
        display: flex;
        align-items: center;
        width: 335px;
        height: 50px;
        margin: 0 auto;
        background: rgba(0, 0, 0, 0.03);
        border: 0 none;
        border-radius: 15px;
        font-size: 14px;
        box-sizing: border-box;
        font-weight: 500;
        input,
        textarea {
          caret-color: #000;
        }
        input::placeholder,
        textarea::placeholder {
          color: #a59c93;
        }
      }
      .van-cell::after {
        display: none;
      }
      .c-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 315px;
        height: 45px;
        margin: 0 auto 5px;
        background: #c293ff;
        border-radius: 28px;
        font-size: 16px;
        font-weight: 600;
        color: #001a33;
        border: 0 none;
        background-image: url("../assets/image/btn-reg.png");
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center top;
      }
      .c-area {
        height: auto;
        border-radius: 10px;
        align-items: baseline;
        box-sizing: border-box;
      }
    }
    .agree {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 20px 10px;
      .t1 {
        font-weight: 400;
        font-size: 11px;
        color: #474747;
      }
      .t-xy {
        color: #8ac4f6;
      }
      .van-checkbox {
        width: 16px;
        .van-checkbox__icon {
          height: auto;
        }
        .van-icon {
          font-size: 9px;
          border: 1px solid #979797;
        }
      }
      .img-icon {
        vertical-align: 1px;
        width: 12px;
        height: 12px;
      }
    }
  }
}
</style>
